import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ManageUsersUserGroupDTO } from '@app/models/users';
import Api from '@app/services/api';

interface IProps {
  user_group_uid: string;
  data: ManageUsersUserGroupDTO;
}

export const useAddUsersQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ user_group_uid, data }: IProps) => {
      await Api.users.putUsersToUserGroup(user_group_uid, data);
      await client.invalidateQueries(['useGetGroupUsersQuery']);
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getGroups']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
    },
  });
};
